import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormArray } from '@angular/forms';

import { filter, map } from 'rxjs/operators';

import { Attachment, Reference } from '@library/common/models';
import { CountriesService, EnumsService } from '@library/core/services';
import { AttachmentService } from '@library/modules/attachment';

import { ShipmentDetailsService } from './shipment-details.service';
import { QuotationDetailsService } from '@library/modules/api-services';
import { forkJoin, Observable } from 'rxjs';
import { IGenericType } from '@library/common/generictype';

@Component({
   selector: 'lib-shipment-details',
   inputs: [ 'hawb' ],
   templateUrl: './details.component.html',
   styleUrls: [ './details.component.scss' ],
})
export class ShipmentDetailsComponent implements OnInit {

   @Input()
   public mode = 'shipment';

   @Input()
   public hawb: string;

   allowNewAttachments = false;

   attachmentUpdates: FormArray = new FormArray( [] );
   searching: boolean;
   searchTerm: string;
   selectedTab: any = 0;
   trackingValues: IGenericType[] = [];

   constructor(
      public countries: CountriesService,
      public enums: EnumsService,
      public details: ShipmentDetailsService,
      public quoteDetails: QuotationDetailsService,

      private attachmentService: AttachmentService,
      private route: ActivatedRoute,
   ) { }

   ngOnInit() {
      this.route.data.pipe( filter( data => data?.allowNewAttachments ))
         .subscribe( data => this.allowNewAttachments = data?.allowNewAttachments );
   }

   get allItems() {
      const l: Observable<any> = this.mode === 'shipment' ?
      this.details.load( this.hawb ) : this.quoteDetails.load( this.hawb );
      return l.pipe(
            map( s => s?.calculator ?? ( s['containers'] ?? [] )
               .filter( c => c?.items?.length )
               .reduce(( a, c ) => [ ...a, ...c?.items ], [] )),
         );
   }

   getBillingPartyRef( shipment: IGenericType ): Reference {
      return shipment?.references?.filter( r => r.party === (shipment?.billingparty ?? shipment?.billingParty) )[0];
   }

   getSortedStatusesById(statuses: any[]): any[] {
      if (!statuses) return [];
      
      return [...statuses].sort((a, b) => a.orderingId - b.orderingId);
   }

   saveAttachments( hawb: string, attachments: Attachment[] ): void {
      this.attachmentService.savingState = 'saving';

      forkJoin( attachments.map(( attch ) => this.attachmentService.uploadAttachment({ hawb, attachments: [attch] })))
         .subscribe( _ => {
            this.attachmentService.savingState = 'show';

            this.attachmentUpdates.clear();
            this.details.reset();
         });
   }

   saveQuoteAttachments( quoteNumber: string, attachments: Attachment[] ): void {
      this.attachmentService.savingState = 'saving';

      forkJoin( attachments.map(( attch ) => this.attachmentService.uploadAttachment({ quoteNumber, attachments: [attch] })))
         .subscribe( _ => {
            this.attachmentService.savingState = 'show';
0
            this.attachmentUpdates.clear();
            this.quoteDetails.reset();
         });
   }
   
   onSearch(event: Event, shipment: any): void {
      const inputValue = (event?.target as HTMLInputElement)?.value || '';
      this.searchTerm = inputValue.toLowerCase().trim();
      this.searching = !!this.searchTerm;
    
      if (!this.searching) {
        this.trackingValues = [];
        return;
      }

      shipment.containers.forEach(container => {
         container.hasMatch = container.status.some(row =>
          row.search.includes(this.searchTerm)
         );
       });
       
    
      const filterStatus = (status: any[]) =>
        status?.filter(row =>
          row.search.includes(this.searchTerm)
          ) || [];
    
      const currentTabHasMatch =
        this.selectedTab > 0 &&
        shipment.containers[this.selectedTab - 1]?.hasMatch;
    
      const firstMatchIndex = shipment.containers.findIndex(c => c.hasMatch);
    
      // oh yeah! current tab has matching search results
      if (currentTabHasMatch) {
        this.trackingValues = filterStatus(shipment.containers[this.selectedTab - 1].status);
      }
      // sadly no matching result on current tab.. oh wait!! there is a matching result on another tab
      else if (firstMatchIndex !== -1) {
        setTimeout(() => {
          this.selectedTab = firstMatchIndex + 1; // +1 because shipment tab is index 0
        });
        this.trackingValues = filterStatus(shipment.containers[firstMatchIndex].status);
      }
      // oh no! no matching result on any tab.. lets go to OG first tab
      else {
        setTimeout(() => {
          this.selectedTab = 0;
        });
        this.trackingValues = [];
      }
    }
    

    clearSearch(shipment: any): void {
      this.searchTerm = '';
      this.searching = false;
      this.onSearch({ target: { value: '' } } as any, shipment);
    }
    
    onTabChange(index: number, shipment:any): void {
      this.selectedTab = index; // +1 because shipment tab is index 0
      this.onSearch({ target: { value: this.searchTerm } } as any, shipment);
    }

    initContainer( container: any ): IGenericType {
      if(container.length === 0) {
        return false;
      }

      const flatten = (status,c): string => {
        return [
          status.date,
          status.location,
          status.status,
          status.description,
          c.number,
        ].join('◬');
    }

      container.forEach(c => {
        c.status.forEach(statusObj => {
          statusObj.search = flatten(statusObj,c).toLowerCase();
        });
      });

      return true;
    }

    trackByIndex(index:number): number {
      return index;
    }

}
